module.exports = Object.freeze([
	{ label: 'Live', key: 'live', order: 0 },
	{ label: 'Submitted', key: 'submitted', order: 1 },
	{ label: 'Approved', key: 'approved', order: 2 },
]);


//////////////////
// WEBPACK FOOTER
// ../server/constants/statuses/timesheet-statuses.js
// module id = 206
// module chunks = 0